import updateToggleMark from './updateToggleMark';
export const commands = {
  updateToggleMark: updateToggleMark
};
flarum.reg.add('bizkaitarra-aurrera-editor', 'common/proseMirror/commands', null);